import { useEffect } from 'react';
import AOS from 'aos';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import WhyChooseSection from '../components/WhyChooseSection';
import ModulesSection from '../components/ModulesSection';
import BenefitsSection from '../components/BenefitsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CustomersSection from '../components/CustomersSection';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import FixedTopBar from '../components/FixedTopBar';

const Index = () => {
  useEffect(() => {
    // Initialize AOS with optimized settings
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
      disable: false,
      startEvent: 'DOMContentLoaded',
      throttleDelay: 99,
      debounceDelay: 50
    });

    // Smooth scrolling for anchor links with delegation
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target && target.hash) {
        e.preventDefault();
        const element = document.querySelector(target.hash);
        if (element) {
          const navbarHeight = 120; // Account for both fixed bars
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);

    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  return (
    <>
      <FixedTopBar />
      <Navbar />
        <HeroSection />
        <FeaturesSection />
        <WhyChooseSection />
        <ModulesSection />
        <BenefitsSection />
        <TestimonialsSection />
        <CustomersSection />
        <FAQSection />
        <ContactSection />
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Index;
